import { Component } from "react";
import { ReactComponent as LoadingIcon } from "../../assets/icons/loading-icon.svg";
import { ReactComponent as Save } from "../../assets/icons/Save.svg";
import { ReactComponent as Warning } from "../../assets/icons/Warning.svg";
import { JobStatusEnum } from "app/models/jobstatus";
import { ButtonIcon } from '@ecosystem/ui-lib/core/components/ButtonIcon';
import { Icons } from '@ecosystem/ui-lib/core/components/Icon';
import jobtrackerService from "app/services/jobtracker.service";
import { GlobalStateContext } from 'app/contexts/GlobalStateContext';
import '../FileDownload/filedownload.scss';

class ConfiguredCopyJobStatus extends Component {
    static contextType = GlobalStateContext;
    constructor(props) {
        super(props);
        this.state = {
            show: true,
            progress: "running",
            message: `Creating copy of '${props.job.surveyName}'...`,
            completed: false
        }
    }

    componentDidMount() {
        this.startPolling(this.props.job.jobId);
    }

    startPolling = (jobId) => {
        this.monitor = setInterval(async () => {
            try {
                var jobStatus = await jobtrackerService.jobStatus(jobId);
                switch (jobStatus.status) {
                    case JobStatusEnum.Completed:
                        clearInterval(this.monitor);
                        this.setState({
                            progress: "completed",
                            message: `Copied '${this.props.job.surveyName}' successfully`,
                            completed: true
                        });
                        const { removeConfiguredCopyJob } = this.context;
                        removeConfiguredCopyJob(jobId);
                        break;
                    case JobStatusEnum.NotFound:
                        clearInterval(this.monitor);
                        this.setState({
                            progress: "failed",
                            message: `Something went wrong. Please try again.`
                        });
                        break;
                    case JobStatusEnum.Failed:
                        clearInterval(this.monitor);
                        this.setState({
                            progress: "failed",
                            message: jobStatus.errorMessage || 'Copy failed with an unknown error'
                        });
                        break;
                    case JobStatusEnum.Submitted:
                    case JobStatusEnum.Running:
                        break;
                    default:
                        break;
                }
            } catch (e) {
                // Ignore polling errors, retry next interval
            }
        }, 3000);
    }

    componentWillUnmount() {
        if (this.monitor) {
            clearInterval(this.monitor);
        }
    }

    renderIcon() {
        const { progress } = this.state;
        switch (progress) {
            case "running":
                return <LoadingIcon className="running" />;
            case "completed":
                return <Save className="completed" />;
            case "failed":
                return <Warning className="failed" />;
            default:
                return null;
        }
    }

    render() {
        if (!this.state.show) return null;

        return (
            <div className="file-download-status">
                <div className="icon">
                    {this.renderIcon()}
                </div>
                <div className="message">
                    <span>
                        {this.state.message}
                        {this.state.completed && (
                            <> - <a href={`/fiveminex?Id=${this.props.job.newSurveyId}`} onClick={(e) => { e.preventDefault(); window.location.href = `/fiveminex?Id=${this.props.job.newSurveyId}`; }}>View survey</a>. </>
                        )}
                    </span>
                </div>
                {(this.state.progress === "completed" || this.state.progress === "failed") && (
                    <div className="close-button">
                        <ButtonIcon onClick={() => this.setState({ show: false })} icon={Icons.Close} />
                    </div>
                )}
            </div>
        )
    }
}

export default ConfiguredCopyJobStatus;
